export function SwirlSynergyIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.27327 17.2501C3.08369 15.1887 3.68851 12.5615 5.65812 11.2273L5.66023 11.2252C7.24247 10.1559 9.32502 10.1918 10.8703 11.3149L14.1308 13.6856C15.6751 14.8087 17.7576 14.8446 19.3409 13.7753L19.343 13.7732C21.3137 12.439 21.9196 9.80969 20.7279 7.75036M17.2522 20.7268C15.1908 21.9163 12.5636 21.3115 11.2294 19.3419L11.2273 19.3398C10.158 17.7576 10.1939 15.675 11.317 14.1297L13.6877 10.8692C14.8108 9.32497 14.8467 7.24242 13.7774 5.65913L13.7732 5.65702C12.439 3.68846 9.80969 3.08153 7.75036 4.27322M19.2174 5.78263C22.9275 9.49281 22.9275 15.5072 19.2174 19.2174C15.5072 22.9275 9.49281 22.9275 5.78263 19.2174C2.07246 15.5072 2.07246 9.49281 5.78263 5.78263C9.49281 2.07246 15.5072 2.07246 19.2174 5.78263Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
